import { cva, VariantProps } from 'class-variance-authority';

export const resizableVariants = cva('flex h-full w-full data-[layout=vertical]:flex-col overflow-hidden', {
  variants: {
    zLayout: {
      horizontal: '',
      vertical: '',
    },
  },
  defaultVariants: {
    zLayout: 'horizontal',
  },
});

export const resizablePanelVariants = cva('relative overflow-hidden flex-shrink-0 h-full', {
  variants: {
    zCollapsed: {
      true: 'hidden',
      false: '',
    },
  },
  defaultVariants: {
    zCollapsed: false,
  },
});

export const resizableHandleVariants = cva(
  'group relative flex flex-shrink-0 items-center justify-center bg-border/50 transition-colors hover:bg-primary/10 focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring focus-visible:ring-offset-1',
  {
    variants: {
      zLayout: {
        horizontal: 'w-[4px] min-w-[4px] cursor-col-resize after:absolute after:inset-y-0 after:left-1/2 after:w-6 after:-translate-x-1/2',
        vertical: 'h-[4px] min-h-[4px] w-full cursor-row-resize after:absolute after:inset-x-0 after:top-1/2 after:h-6 after:-translate-y-1/2',
      },
      zDisabled: {
        true: 'cursor-default pointer-events-none opacity-50',
        false: '',
      },
    },
    defaultVariants: {
      zLayout: 'horizontal',
      zDisabled: false,
    },
  },
);

export const resizableHandleIndicatorVariants = cva('absolute z-10 cursor-grab active:cursor-grabbing flex items-center justify-center bg-gray-100 border transition-all duration-150 group-hover:bg-gray-200 rounded-md text-black shadow-sm', {
  variants: {
    zLayout: {
      vertical: 'w-4 h-6',
      horizontal: 'w-4 h-6',
    },
  },
  defaultVariants: {
    zLayout: 'horizontal',
  },
});

export type ZardResizableVariants = VariantProps<typeof resizableVariants>;
export type ZardResizablePanelVariants = VariantProps<typeof resizablePanelVariants>;
export type ZardResizableHandleVariants = VariantProps<typeof resizableHandleVariants>;
